import { LOGO_URL } from "@/lib/content";
import { useLang } from "@/lib/LanguageContext";

export default function Footer() {
  const { c } = useLang();
  const f = c.footer;
  return (
    <footer data-testid="footer" className="relative bg-forest pt-20 pb-10 border-t border-gold/15">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex justify-center">
          <img src="/logo-transparent.png" alt="Green Gold" className="w-[320px] sm:w-[420px] h-auto" />
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-10 border-t border-gold/15 pt-12">
          <div className="lg:col-span-2">
            <div className="font-serif text-3xl text-cream">
              GREEN <span className="text-gold">GOLD</span><span className="text-gold text-sm align-super">™</span>
            </div>
            <p className="mt-4 font-sans text-sm leading-relaxed text-cream/55 max-w-sm">{f.desc}</p>
          </div>

          <div>
            <div className="font-sans text-[10px] uppercase tracking-[0.2em] text-gold mb-4">{f.navLabel}</div>
            <ul className="space-y-2.5">
              {c.nav.map((l) => (
                <li key={l.href}><a href={l.href} className="font-sans text-sm text-cream/60 link-underline">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-sans text-[10px] uppercase tracking-[0.2em] text-gold mb-4">{f.originsLabel}</div>
            <ul className="space-y-2.5 font-sans text-sm text-cream/60">
              {f.origins.map((o) => (<li key={o}>{o}</li>))}
              <li className="pt-3 text-gold/80 font-serif italic text-base">{f.tagline}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-gold/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="font-sans text-xs text-cream/40">© {new Date().getFullYear()} Green Gold™. {f.rights}</span>
          <span className="font-sans text-xs text-cream/40">{f.subtag}</span>
        </div>
      </div>
    </footer>
  );
}
